<template>
  <article class="card-article">
    <a :href="link | mgnlLink('url')" class="card-article__link">
      <figure v-if="image" class="card-article__figure">
        <div class="card-article__category-icon" v-if="category && category.iconVisible">
          <i :class="`icon-${category.icon}`"></i>
        </div>

        <div class="card-article__figure-wrap">
          <pg-image
              :lazy-src="image | mgnlMedia('url')"
              :width="248"
              :height="186"
          ></pg-image>
        </div>

        <figcaption class="card-article__category" v-if="category">{{ category.title }}</figcaption>
      </figure>
      <div class="card-article__content">
        <div class="card-article__text">
          <time class="card-article__date" :datetime="date">{{date}}</time>

          <h2 class="card-article__title">{{title}}</h2>
        </div>
      </div>
      <i class="card-article__icon icon-plus"></i>
    </a>
  </article>
</template>
<script>
import PgImage from "../Image/Image.vue";

import PgButton from "../Button/Button.vue";

export default {

  name: "CardArticle",
  components: {
    PgButton,
    PgImage
  },
  props:{
    title: {
      type: String,
      required: true,
      default: ""
    },
    link: {
      type: Object
    },
    image: {
      type: Object
    },
    date: {
      type: String
    },
    tag: {
      type: String, // TODO will be an array??
    },
    category: {
      type: Object
    },

  }
};
</script>
